<template>
    <div class="px-30 lg:j-p-0 lg:j-w-1180 mx-auto pt-120 pb-100 lg:j-py-160">
        <h2 class="faq-title">{{ t('member_index.faq.title') }}</h2>
        <ul class="w-full overflow-x-auto px-40 py-8 lg:p-0 lg:j-w-1180 mx-auto lg:j-h-35 flex-start lg:flex-center gap-x-60 lg:j-gap-x-120 mb-42 lg:j-mb-32">
            <li
                v-for="{ id, name, } in faqList"
                :key="id"
                class="group cursor-pointer h-full flex-center flex-shrink-0"
                :class="{ 'active': id === currentId }"
                @click="$event => changeFaqType(id)"
            >
                <span class="text-item">{{ name }}</span>
            </li>
        </ul>
        <div class="lg:j-w-1180 mx-auto py-60 lg:j-py-60 bg-white rounded-16 lg:j-rounded-24">
            <div id="faq-content" class="w-full h-680 lg:j-h-480 overflow-y-auto px-40 lg:j-px-80 flex flex-col gap-y-50 lg:j-gap-y-50">
                <dl v-for="{ question, answer } in content">
                    <dt class="text-24 leading-24 lg:j-text-20 lg:j-leading-20 font-semibold text-black mb-14 lg:j-mb-20">{{ question }}</dt>
                    <dd class="text-20 leading-36 lg:j-text-16 lg:j-leading-24 font-normal text-#808080" v-html="answer"></dd>
                </dl>
            </div>
        </div>
    </div>
</template>
<script setup>
import { cookie, } from '@u/common'
import { getRulePointAndIssueStatus, getCustomerRulePointAndIssueStatus, ruleConfsite} from '@a/index'
import { shopLists } from "@a/userCommon"
import { useStore } from 'vuex';
const store = useStore();
const currentStore = computed(() => store.getters.currentStore);
const CR = currentStore.value.cr;

const { t } = useI18n();

const props = defineProps({
    isLogin: Boolean
})

// 生成 问题和答案 
const createQA = (type, length, params = []) => {
    return [
        ...Array.from({ length, }, (_, i) => ({
            question: t(`member_index.faq.${type}.question_${i+1}`),
            answer: t(`member_index.faq.${type}.answer_${i+1}`, [...params]),
        }))
    ]
}
const faqNum = ['US'].includes(CR) ? 9 : ['CA','GB','EU'].includes(CR) ? 6:5

const faqList = reactive([
    {
        id: 'membership',
        name: t('member_index.faq.membership.title'),
        content: createQA('membership', faqNum),
    },
    {
        id: 'earn-points',
        name: t('member_index.faq.earn_points.title'),
        content: '', // 动态传参
    },
    {
        id: 'redeem',
        name: t('member_index.faq.redeem.title'),
        content: '', // 动态传参
    },
    {
        id: 'others',
        name: t('member_index.faq.others.title'),
        content: createQA('others', 4),
    },
])

const currentId = ref('membership')
const content = ref(faqList[0].content)

const changeFaqType = id => {
    currentId.value = id
    const index = faqList.findIndex(it => it.id === id)
    content.value = faqList[index].content

    // 滚动条归零
    document.querySelector('#faq-content').scrollTop = 0
}


let SHOP_ID = cookie.get("_jk_shop_id") || localStorage.getItem('JACKERY_ID_SHOP_ID')

const getShopId = async () => {
    const { current: { shop_id, }, } = await shopLists()
    return shop_id
}

const getEarnPoints = async (METHOD, params) => {
    const {
        orderCount, // 累计订单数梯度
        orderAmount, // 累计订单金额梯度
    } = await METHOD(params)
    faqList[1].content = createQA('earn_points', 8, [orderCount, orderAmount])
}

// 获取会员2.0配置
const handleConfig = async params => {
    const {
        couponLimitType,
        couponPerDays,
        couponLimit,
        entityCouponLimitType,
        entityCouponPerDays,
        entityCouponLimit,
        giftCardLimitType,
        giftCardPerDays,
        gitfCardLimit,
        otherLimitType,
        otherTypePerDays,
        otherTypeLimit
    } = await ruleConfsite(params)
    // 优惠券文案
    let couponText = ''
    if (couponLimitType === 1) {
        couponText = t('member_index.faq.redeem.setting3')
    }
    if (couponLimitType === 2 ) {
        if (couponPerDays === -1) {
            couponText = t('member_index.faq.redeem.setting2', { time: couponLimit })
        } else {
            couponText = t('member_index.faq.redeem.setting1', { time: couponLimit, num: couponPerDays })
        }
    }
    // 礼品卡文案
    let giftText = ''
    if (giftCardLimitType === 1) {
        giftText = t('member_index.faq.redeem.setting3')
    }
    if (giftCardLimitType === 2 ) {
        if (giftCardPerDays === -1) {
            giftText = t('member_index.faq.redeem.setting2', { time: gitfCardLimit })
        } else {
            giftText = t('member_index.faq.redeem.setting1', { time: gitfCardLimit, num: giftCardPerDays })
        }
    }
    // 实物文案
    let productText = ''
    if (entityCouponLimitType === 1) {
        productText = t('member_index.faq.redeem.setting3')
    }
    if (entityCouponLimitType === 2 ) {
        if (entityCouponPerDays === -1) {
            productText = t('member_index.faq.redeem.setting2', { time: entityCouponLimit })
        } else {
            productText = t('member_index.faq.redeem.setting1', { time: entityCouponLimit, num: entityCouponPerDays })
        }
    }
    
    // 其他文案
    let otherText = ''
    if (otherLimitType === 1) {
        otherText = t('member_index.faq.redeem.setting3')
    }
    if (otherLimitType === 2 ) {
        if (otherTypePerDays === -1) {
            otherText = t('member_index.faq.redeem.setting2', { time: otherTypeLimit })
        } else {
            otherText = t('member_index.faq.redeem.setting1', { time: otherTypeLimit, num: otherTypePerDays })
        }
    }
    faqList[2].content = createQA('redeem', 7, [couponText, giftText, productText, otherText])
}

onMounted(async () => {
    const METHOD = !props.isLogin ? getRulePointAndIssueStatus : getCustomerRulePointAndIssueStatus

    const user = JSON.parse(localStorage.getItem('JACKERY_ID_USER'))
    const uid = user?.uid
    if (!SHOP_ID) {
        getShopId().then(shop_id => {
            const params = {
                shopId: shop_id,
                uid: props.isLogin ? uid : null,
            }
            getEarnPoints(METHOD, params)

            // 获取Redeem Points规则
            const ruleParams = {
                shopId: shop_id
            }
            handleConfig(ruleParams)
        })

        return
    }

    const params = {
        shopId: SHOP_ID,
        uid: props.isLogin ? uid : null,
    }
    getEarnPoints(METHOD, params)
    
    // 获取Redeem Points规则
    const ruleParams = {
        shopId: SHOP_ID
    }

    handleConfig(ruleParams)
})

</script>
<style scoped>
.faq-title {
  @apply
    w-full text-left lg:text-center text-52 leading-64 lg:j-text-48
    lg:j-leading-48 font-semibold text-sub p-40 lg:j-p-0 lg:j-mb-40
}
.text-item {
  @apply
    h-full flex-center text-black/50 text-28 leading-28 py-16 lg:py-0 lg:j-text-18 lg:j-leading-26 font-medium font-medium group-[.active]:text-black relative
    group-[.active]:font-semibold group-[.active]:font-semibold group-[.active]:after:block group-[.active]:after:content-['']
    group-[.active]:after:absolute group-[.active]:after:left-0 group-[.active]:after:bottom-0 
    group-[.active]:after:w-full group-[.active]:after:h-6 group-[.active]:after:rounded-3
    group-[.active]:after:lg:j-h-4 group-[.active]:after:lg:j-rounded-2 group-[.active]:after:bg-primary
}
</style>
